<div class="cb-margin-2x end flex-row">
    <button class="header-button" mat-raised-button color="primary" (click)="exportARInformation()">
        Export AR Information
    </button>
</div>
@if (lotMappedItem.hasClientSale) {
    <div class="cb-margin-2x">
        <h3>Payment Schedule</h3>
        <div class="cb-margin-2x end flex-row">
            @if (lotHasProgressPayments()) {
                @if (!canEditProgressPayments() || !lotIsUnconditional()) {
                    <div class="cb-warn cb-margin-right-2x">
                        <mat-icon ngClass="mat-warn" style="vertical-align: middle">error</mat-icon>
                        {{ getEditPaymentIconTitle() }}
                    </div>
                }
                @if (canEditProgressPayments() && lotIsUnconditional()) {
                    <button
                        mat-raised-button
                        class="cb-margin-right"
                        color="primary"
                        (click)="editProgressPayments()"
                        [matTooltip]="getEditPaymentIconTitle()"
                    >
                        <mat-icon svgIcon="pencil"></mat-icon>
                        Edit Progress Payments
                    </button>
                }
                <button
                    mat-raised-button
                    class="cb-margin-right"
                    color="primary"
                    (click)="viewProgressPaymentHistory()"
                >
                    <mat-icon>history</mat-icon>
                    View History
                </button>
            } @else {
                <div class="cb-warn cb-margin-bottom-2x">
                    <mat-icon ngClass="mat-warn" style="vertical-align: middle">error</mat-icon>
                    Lot has no progress payments
                </div>
            }
        </div>
        <cb-table
            class="cb-margin-top"
            label="Payments"
            [loaded]="progressPaymentLoaded"
            [minWidth]="750"
        >
            <thead cbTableHead>
                <tr cbTableRow>
                    <td>Payment Amount</td>
                    <td>Event/Stage</td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (
                    payment of progressPaymentDto?.payments | cbSortByPipe: 'sortOrder' : 'asc';
                    track payment;
                    let index = $index
                ) {
                    <tr cbTableRow>
                        <td>{{ payment.dollarValue | cbCurrency }}</td>
                        @if (payment.buildStageId) {
                            <cb-td-text [value]="payment.buildStageLabel"> </cb-td-text>
                        }
                        @if (!payment.buildStageId) {
                            <cb-td-enum [value]="payment.trigger" [enum]="BUILD_STAGE_EVENT_ENUM">
                            </cb-td-enum>
                        }
                    </tr>
                }
                @if (lotMappedItem.hasScheduleSpecTemplate) {
                    <tr cbTableRow>
                        <td>
                            <cb-display-value-new class="cb-margin-bottom-nil">
                                {{ balance | cbCurrency }}
                            </cb-display-value-new>
                        </td>
                        <cb-td-text value="Balance"></cb-td-text>
                    </tr>
                }
                <tr cbTableRow class="total-row">
                    <td>
                        <cb-display-value-new class="cb-margin-bottom-nil">
                            {{ progressPaymentDto?.contractPriceWithGst | cbCurrency }}
                        </cb-display-value-new>
                    </td>
                    <cb-td-text value="Contract Amount"></cb-td-text>
                </tr>
                <tr cbTableRow class="total-row">
                    <td>
                        <cb-display-value-new class="cb-margin-bottom-nil">
                            {{ progressPaymentDto?.acceptedVarianceTotalWithGst | cbCurrency }}
                        </cb-display-value-new>
                    </td>
                    <cb-td-text value="Accepted Variance Total"></cb-td-text>
                </tr>
                <tr cbTableRow class="total-row">
                    <td>
                        <cb-display-value-new class="cb-margin-bottom-nil">
                            {{
                                progressPaymentDto?.contractPriceWithGst +
                                    progressPaymentDto?.acceptedVarianceTotalWithGst | cbCurrency
                            }}
                        </cb-display-value-new>
                    </td>
                    <cb-td-text value="Contract Total Inc. Variations"></cb-td-text>
                </tr>
            </tbody>
        </cb-table>
    </div>
}
@if (variations?.length > 0) {
    <div class="cb-margin-2x">
        <h3>Variation Orders</h3>
        <cb-table class="cb-margin-top" label="Payments" [loaded]="true" [minWidth]="750">
            <thead cbTableHead>
                <tr cbTableRow>
                    <td>Variation Order</td>
                    <td>Change</td>
                    <td>Description</td>
                    <td>Amount $</td>
                    <td>Status</td>
                    <td></td>
                </tr>
            </thead>
            <tbody cbTableBody>
                @for (
                    variation of variations | cbSortByPipe: 'sortOrder' : 'asc';
                    track variation;
                    let index = $index
                ) {
                    <tr
                        cbTableRow
                        [ngClass]="isVariationPendingOrAwaiting(variation) ? 'table-pink' : ''"
                    >
                        <td>VO{{ variation.variationNumber }}</td>
                        <td>{{ variation.changeNumber }}</td>
                        <td>
                            {{
                                variation.arChangeDetails
                                    ? variation.arChangeDetails
                                    : variation.changeDetails
                            }}
                        </td>
                        <td>{{ variation.lineCostWithGst | cbCurrency }}</td>
                        <td>{{ VARIATION_STATUS_ENUM[variation.variationStatus] }}</td>
                        <td cbTableShrinkCol cbTableStickyCol="end">
                            <button
                                mat-icon-button
                                [disabled]="!accountsReceivablePermissions.canEditPaymentSchedule()"
                                (click)="editVariationLine(variation)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                        </td>
                    </tr>
                }
                <tr cbTableRow class="total-row">
                    <cb-td-text value="Totals"></cb-td-text>
                    <td></td>
                    <td></td>
                    <td>{{ variationTotals | cbCurrency }}</td>
                    <td></td>
                </tr>
            </tbody>
        </cb-table>
    </div>
}
